<div class="ui segment"  appMargin marginB="3" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" >

		<!-- <div fxFlex>{{project?.id}}</div>
		<div fxFlex="25%">{{project?.name}}</div>
		<div fxFlex>{{project?.projectId}}</div>
		<div fxFlex>{{project?.createdBy}}</div>
		<div fxFlex>{{project?.dateCreated}}</div>
		<div fxFlex>{{project?.amount}}</div>
		<div fxFlex  class="text-right">
			<a class="ui circular tiny button" routerLink="/admin/award/detail/{{project.id}}"><i class="eye icon"></i></a>
		</div> -->

	<!-- <div fxLayout="row" fxLayoutAlign='space-between center'> -->
		<div fxFlex="grow">
			<h3 class="ui primary header">{{project?.name}}</h3>
			<div class="sub-item">PROJECT ID <label class="ui circular label">{{project?.projectId}}</label>  &nbsp; &nbsp;  &nbsp; &nbsp; TYPE <label class="ui circular label">Services</label>
			&nbsp; &nbsp;  &nbsp; &nbsp; DEADLINE <label class="ui circular label">{{project?.dateCreated}}</label>
			&nbsp; &nbsp;  &nbsp; &nbsp; AMOUNT <label class="ui circular label">{{project?.amount}}</label>
			</div>
		</div>
		<div fxFlex="10%">
			<div class="description">CLASS</div>
			<div>PAID</div>
		</div>
		<div fxFlex="20%" class="text-right"><a class="ui circular tiny button" routerLink="/applicant/lot/dasdas"><i class="eye icon"></i></a></div>

	<!-- </div> -->
</div>